/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { useState, useEffect } from 'react';
import {
  FiPocket,
  FiTruck,
} from 'react-icons/fi';
import { useHistory } from 'react-router';
import { ProcessHeader } from '../../../components';

function useDeliveryMethod(commands) {
  const history = useHistory();
  const [homeDeliveryCondition, setHomeDeliveryCondition] = useState();

  const chooseHomeDelivery = (order) => {
    if (order.deliveryMethod !== 'home_delivery') {
      commands.order.changeDataAttributes({
        deliveryMethod: 'home_delivery',
        deliveryDate: undefined,
      });
    }
    commands.process.goToStep(2);
  };
  const chooseGrabAndGo = async (order) => {
    if (order.deliveryMethod !== 'grab_and_go') {
      commands.order.changeDataAttributes({
        deliveryMethod: 'grab_and_go',
        deliveryValue: 0,
        deliveryDate: undefined,
      });
    }
    commands.process.goToStep(2);
  };
  const goBack = () => history.goBack();

  const defineHomeDeliveryCondition = (sharedStates, gratuity) => {
    if (!gratuity || !gratuity.daysOfWeek) return;

    const daysPT = ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'];
    let gratuityDays = '';

    gratuity.daysOfWeek.forEach((dayOfWeek, index) => {
      gratuityDays += ` ${daysPT[dayOfWeek]} 
        ${index < gratuity?.daysOfWeek.length - 2 ? ', ' : ''}
        ${index === gratuity?.daysOfWeek.length - 2 ? ' e ' : ''}
        ${index === gratuity?.daysOfWeek.length - 1
        && gratuity?.kilometerRadius ? ` ou até ${gratuity.kilometerRadius} km` : ''}`;
    });

    setHomeDeliveryCondition((sharedStates?.order?.freeFreight?.minOrderValue)
      ? 'Grátis'
      : sharedStates?.order?.freeFreight?.minOrderValue === false
        ? ((gratuity?.daysOfWeek || gratuity?.kilometerRadius)
          ? (gratuity?.daysOfWeek
            ? `Grátis ${gratuityDays}`
            : `Grátis até ${gratuity.kilometerRadius} km`)
          : 'Frete')
        : 'Vericando...');
  };

  return ({
    localStates: {
      homeDeliveryCondition,
    },
    eventHandlers: {
      chooseHomeDelivery,
      defineHomeDeliveryCondition,
      chooseGrabAndGo,
      goBack,
    },
  });
}

export default function DeliveryMethod(props) {
  const { sharedStates, commands } = props;
  const { order, availableMethods, gratuity } = sharedStates;
  const { deliveryMethod } = order;
  const { eventHandlers, localStates } = useDeliveryMethod(commands);

  useEffect(() => {
    eventHandlers.defineHomeDeliveryCondition(sharedStates, gratuity);
  }, [gratuity, sharedStates]);

  return (
    <section className="step-container">
      <ProcessHeader goBackAction={eventHandlers.goBack} />
      <h1 className="step-title">De que forma deseja obter o produto?</h1>

      <div className="step-options-group">
        {
          availableMethods.includes('grabAndGo')
          && (
            <button
              type="button"
              onClick={() => eventHandlers.chooseGrabAndGo(sharedStates.order)}
              className={`step-option-button ${deliveryMethod === 'grab_and_go' ? 'step-option-selected' : ''}`}
            >
              <div className="step-option-icon">
                <FiPocket size={32} strokeWidth="0.8" />
              </div>

              <div className="step-option-text">
                <h2>Retirada no local</h2>
                <p className="delivery-condition">Grátis</p>
                <p>Marque uma data para retirar seu produto</p>
              </div>
            </button>
          )
        }
        {
          availableMethods.includes('homeDelivery')
          && (
            <button
              type="button"
              onClick={() => eventHandlers.chooseHomeDelivery(sharedStates.order)}
              className={`step-option-button ${deliveryMethod === 'home_delivery' ? 'step-option-selected' : ''}`}
            >
              <div className="step-option-icon">
                <FiTruck size={32} strokeWidth="0.8" />
              </div>
              <div className="step-option-text">
                <h2>
                  Entrega em domicílio
                </h2>
                <p className="delivery-condition">
                  {localStates.homeDeliveryCondition}
                </p>
                <p>
                  Escolha um dia para receber o produtor
                </p>
              </div>
            </button>
          )
        }
      </div>
    </section>
  );
}
